// convex/lib/config/domains/clients.ts

import { validatorClient } from "../../../companies/clients";
import { validatorRecipient } from "../../../companies/clients/recipients";
import { validatorUsers } from "../../../system/users";
import type { DomainGroup, TableScope } from "../types";

// ============================================================================
// CLIENTS DOMAIN - Status Values for i18n
// ============================================================================

/** Tipos de cliente (para i18n) */
export const CLIENT_TYPES = [
  "individual",
  "company",
  "organization",
] as const;

export const clientsDomain: DomainGroup = {
  id: "clients",
  name: "Clientes",
  description: "Gestión de clientes",
  icon: "Users",
  order: 3,
  status: "active",

  // ── Configuración i18n del dominio ────────────────────
  i18n: {
    namespace: "clients",
    keys: {
      title: "clients.title",
      description: "clients.description",
    },
  },

  modules: [
    {
      id: "clients",
      name: "Clientes",
      description: "Remitentes y destinatarios de envíos",
      icon: "UserCircle",
      permissions: ["canCreate", "canRead", "canUpdate", "canDelete"],
      routes: ["/clients"],
      navigation: {
        showInNav: true,
        contexts: ["main"],
        navOrder: 4,
        status: "active",
      },

      // ── Configuración i18n del módulo ────────────────────
      i18n: {
        namespace: "clients.clients",
        keys: {
          title: "clients.clients.title",
          description: "clients.clients.description",
          longDescription: "clients.clients.longDescription",
          searchPlaceholder: "clients.clients.searchPlaceholder",
          emptyState: "clients.clients.emptyState",
          actions: {
            create: "clients.clients.actions.create",
            edit: "clients.clients.actions.edit",
            delete: "clients.clients.actions.delete",
            view: "clients.clients.actions.view",
          },
        },
        translatableFields: ["notes"],
        translatableEnums: [
          { field: "type", values: CLIENT_TYPES },
        ],
      },

      tables: [
        {
          tableName: "clients",
          schema: validatorClient,
          scope: "company" as TableScope,
          relations: [
            {
              key: "lastUpdatedBy",
              sourceField: "internalControl.updatedBy",
              schema: validatorUsers,
              tableName: "users",
            },
          ],
          searchFields: ["name", "code", "email"],
          hasStatusIndex: false,
          customRules: [],
          searchIndex: {
            name: "search_clients",
            field: "name",
          },
        },
        {
          // recipients no tenía config en tableConfigs — schema mínimo por ahora
          tableName: "recipients",
          schema: validatorRecipient,
          scope: "company" as TableScope,
        },
      ],
      readOnlyTables: [{ tableName: "branches" }],
    },
  ],
};
